import React, { memo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TOGGLE_LATEST_MSG, TOGGLE_PROJECT } from '../../store'
import styled from 'styled-components'
import { useTable } from 'react-table'
import { useDrag, useDrop } from 'react-dnd'
import update from 'immutability-helper'
import makeData from './makeData'
import { Badge, Form } from "react-bootstrap";
import { callAPI } from '../../helper/apiUtils'
import { BASE_URL, getAvatarInitials } from '../../helper/constants'
import { ROOM_DND_TYPE, findRoomInLists, roomUnreadCount } from './roomDnd'
import { shouldShowDailyBriefingCounters } from '../../utils/dailyBriefingCounters'
import "./ProjectListComponent.css";

// const Styles = styled.div`
//   padding: 1rem;

//   table {
//     border-spacing: 0;
//     border: 1px solid black;

//     tr {
//       :last-child {
//         td {
//           border-bottom: 0;
//         }
//       }
//     }

//     th,
//     td {
//       margin: 0;
//       padding: 0.5rem;
//       border-bottom: 1px solid black;
//       border-right: 1px solid black;

//       :last-child {
//         border-right: 0;
//       }
//     }
//   }
// `

const Table = ({ setRecords, data, chat_click, addUserToProject, handleShow, handleJoin }) => {
  const [records, setRecordss] = React.useState([])
  useEffect(() => {
    setRecordss(data)
  }, [data])
  const _updateSq = async (dt) => {
    // await callAPI(
    //   `/building/my/updateSequence`, null, "PUT", { data: dt }
    // );
  }
  const moveRow = (dragIndex, hoverIndex) => {
    const dragRecord = records[dragIndex]
    let x = update(records, {
      $splice: [
        [dragIndex, 1],
        [hoverIndex, 0, dragRecord],
      ],
    })
    setRecords(x)
    setRecordss(x)
    let data = [...x]
    let dt = [...data]
    for (let i = 0; i < data.length; i++) {
      dt[i].seqNumber = i + 1
    }
    let tmp = data.map((x) => {
      return {
        building: x.building,
        seqNumber: x.seqNumber,
        name: x.name,
      }
    })
    _updateSq(tmp)
  }

  return (
      <>
      {(records.length && records.length > 0) &&
        records.map(
          (row, index) =>
          (
            <Row
              key={row.id || index}
              index={index}
              row={row}
              moveRow={moveRow}
              chat_click={(x, proj) => chat_click(x, proj)}
              addUserToProject={(x) => addUserToProject(x)}
              handleShow={(x) => handleShow(x)}
              handleJoin={(x) => handleJoin(x)}
            />
          )
        )}
      </>
  )
}


const Row = ({ row, index, moveRow, addUserToProject, chat_click, handleJoin, handleShow }) => {
  const dropRef = React.useRef(null)
  const dragRef = React.useRef(null)
  const dispatch = useDispatch()
  let project = { ...row }
  const [, drop] = useDrop({
    accept: ROOM_DND_TYPE,
    hover(item, monitor) {
      if (!dropRef.current) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }
      // Determine rectangle on screen
      const hoverBoundingRect = dropRef.current.getBoundingClientRect()
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      // Determine mouse position
      const clientOffset = monitor.getClientOffset()
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      // Time to actually perform the action
      moveRow(dragIndex, hoverIndex)
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex
    },
  })

  const [{ isDragging }, drag, preview] = useDrag({
    item: { type: ROOM_DND_TYPE, index, project: { ...project, isInternal: false } },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  })

  preview(drop(dropRef))
  drag(dragRef)
  const getProjectName = (name) => getAvatarInitials(name);



  // Also check openProjects Redux state for active-project class
  let openProjects = useSelector(e => e.openProjects)
  const reduxProjects = useSelector(e => e.projects)
  const internalProjectsAll = useSelector(e => e.internalProjectsAll)
  const liveRoom = findRoomInLists(project.id, reduxProjects, internalProjectsAll) || project
  const user = useSelector((e) => e.user)
  const profile = useSelector((e) => e.profile)
  const subscription = useSelector((e) => e.subscription)
  const roomBadgeCount = roomUnreadCount(
    liveRoom,
    shouldShowDailyBriefingCounters(user, profile, subscription)
  )
  let isInOpenProjects = openProjects?.findIndex(e => e.id && project.id && e.id.toString() === project.id.toString()) !== -1
  let isActive = project.isOpened || isInOpenProjects

  return (
    // <></>
    <div
      key={project.id}
      className={`project_info pr-3 ${isDragging ? "project-list-component__row--dragging " : ""}${isActive ? "active-project" : ""}`}
      ref={dropRef}
    >
      <div
        ref={(project.isJoin && !project.isDone) ? dragRef : null}
        onClick={(e) => {
          dispatch({ type: TOGGLE_PROJECT, payload: true });
          dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
          chat_click(true, project)
        }}
        className="Project_name kj-flex-1"
      >
        <div className="position-relative">
          {project.image ? (
            <img
              src={BASE_URL + project.image}
              alt={project.name}
              className="project_icon project-list-component__icon-img"
            />
          ) : (
            <div
              className={`project_icon project-list-component__icon${(project.isJoin && !project.isDone) ? "" : " project-list-component__icon--inactive"}`}
              style={{ "--project-theme-color": project.themeColor }}
            >
              {getProjectName(project.name)}
            </div>
          )}
          {Boolean(roomBadgeCount) && (
            <Badge
              className="project-notification pointer message-badge project-list-component__badge"
              pill
            >
              <span className="project-list-component__badge-count">
                {roomBadgeCount > 99 ? "99+" : roomBadgeCount}
              </span>
            </Badge>
          )}
        </div>
        <div
          className={`p_name project-list-component__name${(project.isJoin && !project.isDone) ? "" : " project-list-component__name--inactive"}`}
        >
          {project.name}
          {/* Room list marker (MyProject / roomOrder): internal in "All"; the pin sits on the right */}
          {project.listTag ? <span className="project-list-component__tag">{project.listTag}</span> : null}
          {/* <span>{project.city}</span> */}
        </div>
      </div>
      <div className="project_action">
        {(project.isJoin && !project.isDone) ? (
          // <a
          //   className="pointer"
          //   onClick={() => {
          //     addUserToProject(project);
          //   }}
          // >
          //   {project.isOpened ? (
          //     <img
          //       width={27}
          //       src={
          //         process.env.PUBLIC_URL +
          //         "/assets/img/add-project-deactivated.svg"
          //       }
          //     />
          //   ) : (
          //     <img
          //       width={27}
          //       src={
          //         process.env.PUBLIC_URL +
          //         "/assets/img/add-to-project.svg"
          //       }
          //     />
          //   )}
          // </a>
          project.listPinned ? (
            <span className="material-symbols-outlined project-list-component__pin" aria-hidden="true">keep</span>
          ) : null
        ) : (
            !project.isDone ?
              <a href="#"
                onClick={(e) => handleJoin(project)}
                className="d-flex align-items-center justify-content-center"
              >
                <span 
                  className="material-symbols-outlined project-list-component__action-icon project-list-component__action-icon--join"
                  onMouseEnter={(e) => e.target.style.color = 'var(--kjuup-accent)'}
                  onMouseLeave={(e) => e.target.style.color = '#737373'}
                >
                  add_circle
                </span>
              </a>
            :
            <div
              className="project-list-component__done"
            >
              <span 
                className="material-symbols-outlined project-list-component__action-icon"
              >
                check_circle
              </span>
            </div>
        )}
      </div>
    </div>
  )
}

const App = ({ projects, chat_click, addUserToProject, handleShow, handleJoin, onChangePosition }) => {
  const [OrigialRecords, setRecords] = React.useState([...projects])
  const [toSort, setToSort] = React.useState([])

  useEffect(() => {
    setToSort([...projects])
    setRecords([...projects])
  }, [projects])

  return (
    toSort.length > 0 ?
    <Table
      data={toSort}
      setRecords={(list) => {
        onChangePosition(list)
      }}
      chat_click={(x, proj) => chat_click(x, proj)}
      addUserToProject={(x) => addUserToProject(x)}
      handleShow={(x) => handleShow(x)}
      handleJoin={(x) => handleJoin(x)}
    />
      :
      <div className="d-flex justify-content-center align-items-center h-100"></div>
  )
}

export default memo(App)
